import { Container, Feedback } from '@foradevelopment/fora-ui';

import { useTypedTranslation } from '../../i18n/i18n';

export const ReportProcessingFeedback = () => {
  const { t } = useTypedTranslation();
  return (
    <Container marginBottom={60} maxWidth={783}>
      <Feedback type="warning">{t('warningMessages.reportProcessingFeedback')}</Feedback>
    </Container>
  );
};
